import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { AuthProvider } from '../providers/auth';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

/*
  Generated class for the CallHandler provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ConsumerBondHandler {
  url: any;
  token: any;

  constructor(
  		public http: Http,
			public globals: Globals,
      public storage: Storage,
      public authProvider: AuthProvider,
      public httpHelper: HttpHelper) {
    console.log('Hello CallHandler Provider');
  }

  getBonds(params){	
  	this.url = this.globals.dataUrl + 'consumerBond' + 
                                      '/business/' +  params.businessId +
                                      '/category/' +  params.categoryId +

                                      '/page/' + params.page +
                                      '/size/' + params.size;

    this.http.get(
      this.url,
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(res => {
        if(typeof params.cb == "function") params.cb(res.Data);
    });   
  }

  getPinnedBonds(cb){  
    this.url = this.globals.dataUrl + 'consumerBond/pinned';

    this.http.get(
      this.url,
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(res => {
        if(typeof cb == "function") cb(res.Data);
    });   
  }  

  getPurchased(cb){  
    let url = this.globals.dataUrl + 'consumerBond/purchased/redeemed/false';

    this.http.get(
      url,
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(res => {
        if(typeof cb == "function") cb(res.Data);
    });   
  }

  getRedeemed(cb){  
    let url = this.globals.dataUrl + 'consumerBond/purchased/redeemed/true';

    this.http.get(
      url,
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(res => {
        if(typeof cb == "function") cb(res.Data);
    });   
  }  

  getPurchasedById(id, cb){  
    this.url = this.globals.dataUrl + 'consumerBond/purchased/' + id;

    this.http.get(
      this.url,
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(res => {
        if(typeof cb == "function") cb(res.Data);
    });   
  }  

  getBondDetail(id, cb){
  	this.url = this.globals.dataUrl + 'consumerBond/' + id;

    this.http.get(this.url).map(res => res.json())
	  .subscribe(res => {
        if(typeof cb == "function") cb(res.Data);
    });    	    	
  }

  buyBond(params, cb){
    this.url = this.globals.dataUrl + 'consumerBond/buy/' + params.bond.Id;

    let expiry = params.method.expiry.split('/');

    var body = {
      cardNumber: params.method.number,
      expirationMonth: expiry[0].trim(),
      expirationYear: expiry[1].trim(),
      cvc: params.method.cvc,
      amount: params.bond.BondPrice                       
    }

    this.http
    .post(
      this.url, 
      body, 
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(response => {
        if(typeof cb == "function") cb(response);
    });             
  }

  pinBond(params, cb){
    this.url = this.globals.dataUrl + 'consumerBond' + 
                      '/bond/' + params.bondId + 
                      '/pin/' + params.pinned;

    this.http
    .post(
      this.url, 
      null, 
      this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
    )
    .map(res => res.json())
    .subscribe(response => {
        if(typeof cb == "function") cb(response.Data);
    });             
  }  

}



// WEBPACK FOOTER //
// ./src/providers/consumer-bond-handler.ts